<template>
  <th v-if="isHeader">
    {{'Actions' | trans}}
  </th>
  <td v-else>
    <div class="custom-actions">
      <button class="btn btn-primary mb-1" @click="addToReport(rowData, rowIndex)"><i class="icons icon-plus"></i>&nbsp;{{'Add to report' | translate }}</button>
    </div>
  </td>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'
export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    addToReport (data, index) {
      this.$store.commit('setCurrentReport', data)
    }
  }
}
</script>


// WEBPACK FOOTER //
// VueTableJointActions.vue?25deb874